import { BRAND_LIST } from 'typings'
import * as Typings from '../typings'

const ChinaLocale: Typings.LocaleType = {
  REGION: Typings.RegionGroupNames.ASIA,
  CODE: 'cn',
  LANGUAGE_CODE: 'zh',

  LONG_NAME: 'China',
  SHORT_NAME: 'zh',

  DISPLAY_NAME: '中国',
  DISPLAY_COUNTRY: '中国',

  LANGUAGES: {
    ZH: 'zh',
  },

  GEO_COORDINATES: {
    INITIAL_LATITUDE: 33.92920123358008,
    INITIAL_LONGITUDE: 138.42930714999994,
    INITIAL_ZOOM: 4,
    INITIAL_ZOOM_DETAILS_PAGE: 15,
  },

  AREAS: {},

  HOME_PAGE_URL: 'https://www.uniqlo.com',

  MAP_URL: 'https://www.uniqlo.cn/shop/shop_list.html',
  MAP_MOBILE_URL: 'https://h.uniqlo.cn/#/store_entrance',

  TERMS_OF_USE_URL: 'https://www.uniqlo.com',
  PRIVACY_POLICY_URL: 'https://www.uniqlo.com',

  POSTCODE_FORMAT: /[0-9]{5}/g,

  CLIENT_ID: {
    [BRAND_LIST.UQ]: '',
  },

  AM_FORMAT: ' AM',
  PM_FORMAT: ' PM',
}

export default ChinaLocale
